import React from 'react';
import classnames from 'classnames';
import { arrayOf, object, number, string, shape } from 'prop-types';
import { LoadingGigCardCarousel } from '@fiverr-private/gig_listings';
import { LoadingPlaceholder } from '../LoadingPlaceholder';
import { PLACEHOLDER_CLASS_NAME, DEFAULT_SLIDER_BASE_NUM, DEFAULT_SLIDER_BREAKPOINTS } from '../constants';

const SIZE = {
    height: '28px',
    width: '70%',
};

const GigsSectionPlaceholder = ({
    className,
    slidesToShow = DEFAULT_SLIDER_BASE_NUM,
    sliderBreakpoints = DEFAULT_SLIDER_BREAKPOINTS,
    headerSize = SIZE,
}) => (
    <div className={classnames(PLACEHOLDER_CLASS_NAME, 'gigs-section-placeholder', className)}>
        <LoadingPlaceholder className="m-b-28" type="textRow" {...headerSize} />
        <LoadingGigCardCarousel slidesToShow={slidesToShow} sliderBreakpoints={sliderBreakpoints} />
    </div>
);

GigsSectionPlaceholder.propTypes = {
    className: string,
    slidesToShow: number,
    sliderBreakpoints: arrayOf(object),
    headerSize: shape({
        height: string,
        width: string,
    }),
};

export default GigsSectionPlaceholder;
